import { render, staticRenderFns } from "./Acknowledge.vue?vue&type=template&id=261f4d7d&scoped=true&"
import script from "./Acknowledge.vue?vue&type=script&lang=js&"
export * from "./Acknowledge.vue?vue&type=script&lang=js&"
import style0 from "./Acknowledge.vue?vue&type=style&index=0&id=261f4d7d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "261f4d7d",
  null
  
)

export default component.exports